<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup Widget
 * @created at      :   2025/09/18
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupWidget from '@/views/popupSearch/popup_area/store';
import Widget001 from '@/views/move/mng_widget/MNG_Widget001/index';
import Widget002 from '@/views/move/mng_widget/MNG_Widget002/index';
import Widget003 from '@/views/move/mng_widget/MNG_Widget003/index';
import Widget004 from '@/views/move/mng_widget/MNG_Widget004/index';
/**
 * Define component for popup Fab040120i
 */
import helpers from '@/utils/helpers';

var Area = {
    template: template,
    components: { Widget001, Widget002, Widget003, Widget004 },
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupWidget')) {
            store.registerModule('PopupWidget', PopupWidget);
        }
    },
    created() {
        this.onInitScreen();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupWidget', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupWidget', ['searchAreaInfo']),
        ...mapMutations('PopupWidget', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchAreaInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchAreaInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        selectWidget(code) {
            const map = {
                1: '承認一覧',
                2: '申請一覧',
                3: '売上総計',
                4: '販売情報'
            };
            this.$emit('onReferModelValue', code);
            this.$emit('onReferValueName', map[code]);
            this.$emit('close');
        }
    }
};
export default Area;
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/popup.scss';
/* Áp dụng cho tất cả v-card trong #modal_Area */
#modal_Area .v-card {
    position: relative;
    transition: all 0.3s ease;
    cursor: pointer;
}
/* Hiệu ứng khi hover */
#modal_Area .v-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}
</style>
